<template>
  <div class="exchanges-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header
      :title="`${exchangeId ? 'Editar' : 'Cadastrar'} Câmbio`"
    ></app-page-header>

    <app-card>
      <exchanges-form
        @submit="onSubmit"
        :id="exchangeId"
        :errors="errors"
        :saving="isSaving"
      ></exchanges-form>
    </app-card>
  </div>
</template>

<script>
import ExchangeService from '@/services/exchange.service';
import ExchangesForm from '@/components/Forms/ExchangesForm.vue';

export default {
  name: 'exchanges-form-page',
  components: {
    ExchangesForm,
  },
  data: () => {
    return {
      exchangeId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(data) {
      this.errors = {};
      this.exchangeId && this.update(this.exchangeId, data);
      !this.exchangeId && this.save(data);
    },
    save(data) {
      this.isSaving = true;
      ExchangeService.save(data)
        .then(() => {
          this.toastify('Câmbio cadastrado com sucesso!');
          //this.$router.push({ name: "exchanges.index" });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Câmbio.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, data) {
      this.isSaving = true;
      ExchangeService.update(id, data)
        .then(() => {
          this.toastify('Câmbio atualizado com sucesso!');
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Câmbio.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.exchangeId = 1;
  },
};
</script>
